import { Button, Col, Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Image = styled.video`
  width: 72px;
  height: 97px;
  position: absolute;
  top: 0;
  left: 0;
`;

const NormalText = styled.span`
  font-weight: 400;
`;

const ShoutoutSuccess = ({ handleClose, userData }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <Col wid="100%" marg="8px 0 0" center between>
        <Col marg="0 0 0" wid="100%" center>
          <Text h2 marg="40px 0 0" col="black">
            {t('requestShoutout.requestSent')}
          </Text>
          <Text marg="2px 0 0" col="black">
            {t('requestShoutout.requestConfirmation', { athlete: userData.name, day: '7' })}
          </Text>
          <div style={{ flex: 1, marginTop: '10px' }}></div>
          <Button
            bg={theme.SECONDARY}
            text={t('requestShoutout.backToShoutout')}
            containerStyle={{ marginBottom: 100, marginTop: 50 }}
            onClick={handleClose}
          />
        </Col>
      </Col>
    </React.Fragment>
  );
};

export default ShoutoutSuccess;
